import {Row, Typography} from "@bezlimit/bezlimit-ui";
import "./style.scss";
import _ from "lodash";
import {observer} from "mobx-react";
import React from "react";
// servise
import DeliveryService from "../../../../../services/DeliveryService";
import ListRow from "./listRow";

export default React.memo(
    observer(function List() {
        return (
            <Typography as="div" className="bl-widget-delivery-list">
                <Row gutter={[16, 32]}>
                    {_.chain(DeliveryService.items)
                        .map((props) => <ListRow key={props.id} {...props} />)
                        .valueOf()}
                </Row>
            </Typography>
        );
    })
);
